export default __webpack_public_path__ + "static/media/join_bg.1778540d.jpg";